import { cn } from 'src/shared/lib/utils';

type ShimmerLoaderProps = {
  width?: number;
  height?: number;
  className?: string;
};

export default function ShimmerLoader({ width, height, className }: ShimmerLoaderProps) {
  const style = {
    width: width ? `${width}px` : 'full',
    height: height ? `${height}px` : 'full',
  };

  return (
    <div className={cn('shimmer-container bg-slate-100 rounded-sm', className)} style={style}>
      <div className="shimmer" />
    </div>
  );
}
